(() => {
  const format = (text, values = {}) => String(text || '').replace(/\{(\w+)\}/g, (_, key) => String(values[key] ?? ''));
  const inclusions = (state, labels) => {
    const { handle, quantity = 1, guests = 0, drinks = 0, hours = 3, plate, napkin, cloth, florals, drinkware, menu, furniture } = state;
    const values = { quantity, guests, drinks, hours, plate, napkin, cloth, florals, drinkware, menu };
    const keys = handle === 'la-table'
      ? ['tables','plates','napkins','cutlery','water_glasses','drinks','drinkware','linen','florals','candles',...(furniture ? ['furniture'] : []),'self_serve','hire']
      : handle === 'l-or'
        ? ['hosted_drinks','drinkware','bar','umbrella','mirror','menu_easel','hosted_florals','hosted','hire']
        : handle === 'la-coupe-welcome-toast-table'
          ? ['drinks','drinkware','linen','coupe_display','coupe_florals','cooler','sign','self_serve','hire']
          : handle === 'olouioo-signature-coupe-tower-setup-upgrade'
            ? ['drinks','drinkware','linen','tower_display','coupe_florals','self_serve','hire']
            : state.hosted ? ['hosted_drinks','drinkware','hosted','hire'] : ['drinks','drinkware',...(cloth ? ['linen'] : []),'self_serve','hire'];
    return keys.map(key => format(labels[key], values)).filter(Boolean);
  };
  const eventSummary = (owner, labels) => {
    const date = owner?.querySelector('[data-event-date]')?.value;
    const start = owner?.querySelector('[data-start-time]');
    const duration = owner?.querySelector('[data-hire-duration]');
    const finish = owner?.querySelector('[data-finish-time]')?.value;
    let day = '';
    if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [year, month, dateNumber] = date.split('-').map(Number);
      day = new Intl.DateTimeFormat(document.documentElement.lang || 'en-AU', { day:'numeric', month:'short', year:'numeric' }).format(new Date(year, month - 1, dateNumber));
    }
    return [day, start?.value ? start.selectedOptions?.[0]?.textContent.trim() || start.value : '', duration?.value ? Number(duration.value) >= 24 ? duration.selectedOptions[0]?.textContent.trim() : format(labels.selected_hire,{hours:duration.value}) : '', finish ? format(labels.finishes,{time:finish}) : ''].filter(Boolean);
  };
  window.OlouiooServiceDetails = { format, inclusions, eventSummary };
})();

